import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, Pagination, Spin, Row, Col } from 'antd'
import { getAllTaxes } from '../../actions/orderActions'
import TaxCard from '../../components/TaxCard'
import Colors from '../../utils/colors'
import Constants from '../../utils/constants'

const { Title } = Typography

const NewOrders = () => {
  const dispatch = useDispatch()
  const { taxes, loading, totalTaxes } = useSelector((state) => state.allTaxes)
  const { user } = useSelector((state) => state.user)
  const [page, setPage] = useState(1)
  const [perPage] = useState(50)

  const fetchTaxes = (pageNum = page) => {
    if (user) {
      dispatch(getAllTaxes({
        states: user.states,
        category: user.categories,
        status: Constants.ORDER_STATUS.CONFIRMED,
        sort: 'asc',
        page: pageNum,
        perPage
      }))
    }
  }

  useEffect(() => {
    fetchTaxes()
    const interval = setInterval(() => fetchTaxes(), 5000)
    
    return () => clearInterval(interval)
  }, [user, page])

  const handlePageChange = (newPage) => {
    setPage(newPage)
    fetchTaxes(newPage)
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <Title level={4} style={{ color: Colors.primary, margin: 0 }}>
          New Orders
        </Title>
        <Title level={5} style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
          {totalTaxes || 0} Total Orders
        </Title>
      </div>
      
      <Spin spinning={loading}>
        <Row gutter={[16, 16]}>
          {taxes?.map((tax) => (
            <Col xs={24} sm={12} md={8} lg={8} key={tax._id}>
              <TaxCard tax={tax} onRefresh={() => fetchTaxes(page)} />
            </Col>
          ))}
        </Row>
        
        {taxes?.length === 0 && !loading && (
          <div style={{ textAlign: 'center', padding: '40px', color: Colors.darkGray }}>
            No new orders found
          </div>
        )}
      </Spin>
      
      {totalTaxes > 0 && (
        <div style={{ marginTop: '24px', textAlign: 'center' }}>
          <Pagination
            current={page}
            total={totalTaxes}
            pageSize={perPage}
            onChange={handlePageChange}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} orders`}
            itemRender={(current, type, originalElement) => {
              if (type === 'page') {
                return (
                  <span style={{
                    backgroundColor: current === page ? Colors.primary : 'transparent',
                    color: current === page ? Colors.white : Colors.primary,
                    border: `1px solid ${Colors.primary}`,
                    padding: '4px 8px',
                    borderRadius: 4,
                    cursor: 'pointer'
                  }}>
                    {current}
                  </span>
                )
              }
              return originalElement
            }}
          />
        </div>
      )}
    </div>
  )
}

export default NewOrders